import { render, staticRenderFns } from "./GetMicroData.vue?vue&type=template&id=6d338854&scoped=true&"
import script from "./GetMicroData.vue?vue&type=script&lang=js&"
export * from "./GetMicroData.vue?vue&type=script&lang=js&"
import style0 from "./GetMicroData.vue?vue&type=style&index=0&id=6d338854&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d338854",
  null
  
)

export default component.exports